import { useEffect, useState } from "react";
import { toast } from "../lib/notify";
import { FileDown, Briefcase } from "lucide-react";
import { http, formatApiError, downloadUrl } from "../lib/api";
import { fmtDate } from "../lib/format";
import WorkAreas from "./WorkAreas";

// Personel kartı → Görevlendirme Kayıtları: geçici olarak nerede, ne zaman, kaç gün, kimin yerine çalıştı (pozisyon değişse de silinmez)
export default function TempAssignmentHistory({ personId, workAreas }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { if (personId) http.get(`/temp-assignments?personnel_id=${personId}`).then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e))); }, [personId]);
  if (!personId) return <div className="text-xs text-slate-500" data-testid="ta-new">Kart kaydedildikten sonra görevlendirme kayıtları burada listelenir.</div>;
  const totalDays = rows.reduce((s, r) => s + (r.days || 0), 0);
  return (
    <div className="space-y-3" data-testid="ta-history">
      <WorkAreas personId={personId} initial={workAreas} />
      <div className="flex items-center gap-3 flex-wrap">
        <span className="inline-flex items-center gap-1.5 text-sm font-bold text-slate-800"><Briefcase className="w-4 h-4 text-sky-700" /> Görevlendirme Kayıtları</span>
        <span className="text-xs text-slate-600" data-testid="ta-summary">{rows.length} görevlendirme · toplam <b>{totalDays}</b> gün</span>
        <a href={downloadUrl(`/temp-assignments/export?personnel_id=${personId}`)} target="_blank" rel="noreferrer" data-testid="ta-export" className="ml-auto inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md bg-emerald-700 text-white text-xs font-semibold hover:bg-emerald-800"><FileDown className="w-3.5 h-3.5" /> Excel</a>
      </div>
      <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white">
        <table className="tbl text-xs w-full">
          <thead><tr className="text-[10px] uppercase tracking-wider text-slate-600 bg-slate-50">{["Proje", "Şube", "Kimin Yerine", "Görev Başlangıç", "İşbaşı (Bitiş)", "Gün", "Dönem", "Açıklama"].map((h) => <th key={h} className="px-3 py-2 text-left whitespace-nowrap">{h}</th>)}</tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={8} className="px-3 py-6 text-center text-slate-400" data-testid="ta-empty">Görevlendirme kaydı yok</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`ta-row-${r.id}`}>
                <td className="px-3 py-1.5 font-semibold">{r.project_name}</td>
                <td className="px-3 py-1.5">{r.location_name}</td>
                <td className="px-3 py-1.5">{r.replaced_name ? `${r.replaced_tc} - ${r.replaced_name}` : "—"}</td>
                <td className="px-3 py-1.5 whitespace-nowrap">{fmtDate(r.start_date)}</td>
                <td className="px-3 py-1.5 whitespace-nowrap">{fmtDate(r.end_date)}</td>
                <td className="px-3 py-1.5 text-right font-bold">{r.days}</td>
                <td className="px-3 py-1.5 font-mono">{r.period}</td>
                <td className="px-3 py-1.5 text-slate-600">{r.description || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
